import React, {useContext, useEffect, useState, useMemo} from 'react';

import {useTranslation} from 'react-i18next';
import TablePagination from '../../../TablePagination';
import InputFilter from '../../../Filters/InputFilter';
import SelectComponent from '../../../Selects/SelectFilter';
import {getDados, getNegocios, getRepresentantes} from '../../../../pages/requests';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import Datepicker from 'react-tailwindcss-datepicker';
import Spinner from '../../../../components/Spinner';
import NotFound from '../../../NotFound';
import axios from 'axios';
import moment from 'moment';
import MultiSelect from '../../../Selects/MultiSelect';
import {Context} from '../../../../Helpers/Auth';

function HistoricoOportunidades({info}) {
    const FORMATO_DATA = 'YYYY-MM-DD';

    const {
        prospect,
        //historico de oportunidades
        filtroNomeHistorico,
        setFiltroNomeHistorico,
        filtroEtapa,
        setFiltroEtapa,
        filtroRepHisOp,
        setFiltroRepHisOp,
        filtroEmpresa,
        setFiltroEmpresa,
        filtroDt,
        setFiltroDt,
        filtroValorHistorico,
        setFiltroValorHistorico,
        etapasHistoricoOp,
        setEtapasHistoricoOp,
        representantesHistoricoOp,
        setRepresentantesHistoricoOp,

        filtroCodigoHistorico,
        setFiltroCodigoHistorico,
    } = info;
    const {t} = useTranslation();
    const [historicoOportunidades, setHistoricoOportunidades] = useState([]);
    const {acessos, utilizador, rep} = useContext(Context);
    const [loading, setLoading] = useState(true);
    const [semDados, setSemDados] = useState(false);
    const [totalProdutos, setTotalProdutos] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRegistos, setTotalRegistos] = useState(0);

    const [isMobile, setIsMobile] = useState(false);

    const {isCard, openCards, formatarNumero} = useContext(Context);

    const handleResize = () => {
        setIsMobile(window.innerWidth < 900);
    };

    const ITEMS_PER_PAGE = 15;

    // // Filtros tabela
    // const [filtroNomeHistorico, setFiltroNomeHistorico] = useState('');
    // const [filtroEtapa, setFiltroEtapa] = useState('');
    // const [filtroRepHisOp, setFiltroRepHisOp] = useState('');

    // const [filtroEmpresa, setFiltroEmpresa] = useState('');
    // const [filtroDt, setFiltroDt] = useState({
    //     startDate: '',
    //     endDate: '',
    // });
    // const [filtroValorHistorico, setFiltroValorHistorico] = useState(0);

    // const [etapasHistoricoOp, setEtapasHistoricoOp] = useState([]);
    // const [representantesHistoricoOp, setRepresentantesHistoricoOp] = useState([]);

    const [formattedDate, setFormattedDate] = useState('');

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        setHistoricoOportunidades([]);

        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
        getNegocios(
            indexOfFirstItem,
            indexOfLastItem - 1,
            lang,
            signal,
            false,
            false,
            '',
            filtroRepHisOp ? [filtroRepHisOp] : [],
            0,
            filtroNomeHistorico,
            filtroEtapa ? [filtroEtapa] : [],
            prospect?.codigoCliente,
            filtroDt.startDate ?? '',
            filtroDt.endDate ?? '',
            filtroValorHistorico,
            '',
            '',
            '',
            '',
            '',
            '',
            '',
        )
            .then(res => {
                debugger;
                if (res.data.negocios.length !== 0) {
                    setTotalProdutos(res.data.negocios.length);
                    setTotalRegistos(res.data.totalprodutos);

                    setHistoricoOportunidades(res.data.negocios);
                } else {
                    setSemDados(true);
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) console.log(error);
            })
            .finally(() => {
                setLoading(false);
            });

        return () => {
            controller.abort();
        };
    }, [setFiltroNomeHistorico, filtroEtapa, filtroRepHisOp, filtroEmpresa, filtroDt, setFiltroValorHistorico, filtroValorHistorico]);

    useEffect(() => {
        setEtapasHistoricoOp(
            historicoOportunidades
                ?.map(e => e.descricaoEtapa)
                .filter((ele, index, self) => self.indexOf(ele) === index && !!ele)
                .map(e => {
                    return {value: e, label: e};
                }),
        );

        getRepresentantes(lang).then(res => {
            setRepresentantesHistoricoOp(res.data.representantes);
        });
    }, []);

    function showButton() {
        if (setFiltroNomeHistorico || filtroEtapa.length > 0 || filtroRepHisOp.length > 0 || filtroEmpresa || filtroDt.startDate || setFiltroValorHistorico) {
            return true;
        } else {
            return false;
        }
    }

    function limparFiltros() {
        //setFiltroCodigoHistorico('');
        setFiltroNomeHistorico('');
        setFiltroEtapa([]);
        setFiltroRepHisOp([]);
        setFiltroEmpresa('');
        setFiltroValorHistorico('');
        setFiltroDt({
            startDate: null,
            endDate: null,
        });
        setFiltroRepHisOp('');
    }

    useEffect(() => {
        if (historicoOportunidades.length == 0) {
            setSemDados(true);
        } else {
            setSemDados(false);
        }
    }, [historicoOportunidades]);

    return (
        <>
            <div>
                {isMobile || isCard ? (
                    <div>
                        {historicoOportunidades?.map((dados, index) => (
                            <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                                <h2 className="mb-0" id="headingOne">
                                    <button
                                        className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                        type="button"
                                        data-te-collapse-init
                                        data-te-collapse-collapsed
                                        data-te-target={'#flush-collapseThree' + index}
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThree">
                                        <div className="flex flex-row">
                                            {dados.nome} - {dados.descricaoEtapa}
                                        </div>
                                        <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                            </svg>
                                        </span>
                                    </button>
                                </h2>
                                <div
                                    id={'flush-collapseThree' + index}
                                    className={openCards ? 'visible' : '!visible hidden'}
                                    data-te-collapse-item
                                    aria-labelledby="flush-headingThree"
                                    data-te-parent="#accordionFlushExample">
                                    <div className="px-5 py-4">
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('etapa')}:</div> {dados.descricaoEtapa}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('representante')}: </div> {dados.responsavel.label}
                                        </div>
                                        {/* <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('empresa')}: </div> {dados.empresa}
                                        </div> */}
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('dataCriacao')}: </div> {moment(dados.dataCriacao).format(FORMATO_DATA)}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('valor')}: </div>{' '}
                                            <a href="#" className=" flex justify-end text-blue-600 dark:text-blue-500 font-medium  hover:underline">
                                                {formatarNumero(dados.valor)}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}

                        {/* {loading && (
                            <div className="flex flex-row mt-14 justify-center">
                                <>
                                    <Spinner />
                                </>
                            </div>
                        )} */}
                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalRegistos / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalRegistos}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            <TablePagination total={totalRegistos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                        </nav>

                        <div className="mb-4">{semDados && <NotFound frase={t('semRegistos')} />}</div>
                    </div>
                ) : (
                    <div className="relative min-h-[400px] overflow-x-auto shadow-md sm:rounded-[8px]">
                        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                                <tr>
                                    <th scope="col" className="px-6 py-3">
                                        {t('nome')}
                                        <InputFilter
                                            onSearch={value => {
                                                setFiltroNomeHistorico(value);
                                            }}
                                        />
                                    </th>

                                    <th scope="col" className="px-6 py-3">
                                        {t('etapa')}

                                        <SelectComponent
                                            options={etapasHistoricoOp}
                                            value={filtroEtapa}
                                            onChange={e => {
                                                setFiltroEtapa(e);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        {t('representante')}
                                        <SelectComponent
                                            options={representantesHistoricoOp}
                                            value={filtroRepHisOp}
                                            onChange={e => {
                                                setFiltroRepHisOp(e);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        {t('empresa')}
                                        <InputFilter
                                            onSearch={value => {
                                                setFiltroEmpresa(value);
                                            }}
                                        />
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        {t('dataCriacao')}
                                        <Datepicker
                                            displayFormat={FORMATO_DATA}
                                            useRange={false}
                                            asSingle={false}
                                            value={filtroDt}
                                            onChange={newValue => {
                                                setFiltroDt(newValue);
                                            }}
                                            inputClassName={`rounded-[8px] mt-2 w-full bg-white border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                        />
                                    </th>
                                    <th scope="col" className="px-6 py-3 w-80">
                                        {t('valor')}
                                        <div className="flex flex-row">
                                            <InputFilter
                                                value={filtroValorHistorico}
                                                onSearch={value => {
                                                    setFiltroValorHistorico(value == '' ? 0 : value);
                                                }}
                                            />
                                            {showButton() && (
                                                <button
                                                    onClick={limparFiltros}
                                                    type="button"
                                                    className="flex items-center border-gray-300 text-gray-600 hover:text-blue-600 bg-gray-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] ml-2 text-xs  text-center dark:bg-gray-600 dark:text-white dark:hover:text-blue-500 dark:focus:ring-blue-800">
                                                    <FilterAltOffIcon />
                                                </button>
                                            )}
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {historicoOportunidades?.map(dados => (
                                    <tr
                                        className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 "
                                        //  onClick={() => handleRowClick(dados)}
                                    >
                                        <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            {dados.nome}
                                        </th>
                                        <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            {dados.descricaoEtapa}
                                        </th>
                                        <td className="px-6 py-1">{dados.responsavel.label}</td>
                                        <td className="px-6 py-1 text-blue-600 dark:text-blue-500">{dados.empresa}</td>
                                        <td className="px-6 py-1">{moment(dados.dataCriacao).format(FORMATO_DATA)}</td>
                                        <td className="px-6 py-1">
                                            <a href="#" className=" flex justify-end text-blue-600 dark:text-blue-500 font-medium  hover:underline">
                                                {/* {new Intl.NumberFormat('de-DE', {
                                                    style: 'currency',
                                                    currency: 'EUR',
                                                }).format(dados.valor)} */}
                                                {formatarNumero(dados.valor)}
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {semDados && <NotFound frase={t('semRegistos')} />}

                        {totalProdutos === undefined && <NotFound frase={t('naoExistemHistoricos')} />}

                        {loading && (
                            <div className="flex flex-row mt-14 mb-14 justify-center">
                                <>
                                    <Spinner />
                                </>
                            </div>
                        )}

                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalRegistos / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalRegistos}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            <TablePagination total={totalRegistos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                        </nav>
                    </div>
                )}
            </div>
        </>
    );
}

export default HistoricoOportunidades;
